import { useEffect, useState } from 'react';
import {
  fetchExchanges,
  fetchItemShopWallet,
  type ExchangeItem,
  type ItemShopWallet,
} from './api';
import { useOneliveSession } from './useOneliveSession';

export function useItemShopWalletData(exchangesLimit = 50) {
  const { isAuthed, authReady } = useOneliveSession();
  const [loading, setLoading] = useState(true);
  const [wallet, setWallet] = useState<ItemShopWallet | null>(null);
  const [exchanges, setExchanges] = useState<ExchangeItem[]>([]);

  useEffect(() => {
    if (!authReady) return;

    let mounted = true;
    setLoading(true);

    (async () => {
      try {
        if (!isAuthed) {
          if (mounted) {
            setWallet(null);
            setExchanges([]);
          }
          return;
        }

        const [walletData, exchangeList] = await Promise.all([
          fetchItemShopWallet(),
          fetchExchanges(exchangesLimit),
        ]);

        if (!mounted) return;
        setWallet(walletData);
        setExchanges(Array.isArray(exchangeList) ? exchangeList : []);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => { mounted = false; };
  }, [authReady, isAuthed, exchangesLimit]);

  return { loading, wallet, exchanges, authReady, isAuthed };
}
